(function() { /* Start dojo-webpack-plugin extensions */
		function mix(dest, src) { // eslint-disable-line no-unused-vars
			for(var n in src) dest[n] = src[n];
			return dest;
		}

		function toUrl(name, referenceModule) {
			return loaderScope.require.toUrl(name, referenceModule);
		}

		function toAbsMid(name, referenceModule) {
			return loaderScope.require.toAbsMid(name, referenceModule);
		}

		// dojo require function.
		function req(config, dependencies, callback) {
			return contextRequire(config, dependencies, callback, 0, req);
		};

		function createContextRequire(module) { // eslint-disable-line no-unused-vars
			if (!module) return req;
			var moduleId = module.absMid;
			if (!moduleId && req.absMidsById[module.id]) {
				moduleId = req.absMidsById[module.id];
			}
			if (!moduleId) return req;
			var result = function(a1, a2, a3) {
				return contextRequire(a1, a2, a3, moduleId, req);
			};
			for (var p in req) {
				if (req.hasOwnProperty(p)) {
					result[p] = req[p];
				}
			}
			result.toUrl = function(name) {
				return toUrl(name, moduleId ? {mid: moduleId} : null);
			};
			result.toAbsMid = function(name) {
				return toAbsMid(name, moduleId ? {mid: moduleId} : null);
			};

			if (req.undef) {
				result.undef = function(mid) {
					req.undef(mid, moduleId);
				};
			}
			return result;
		}

		function registerAbsMids(absMids) { // eslint-disable-line no-unused-vars
			for (var s in absMids) {
				req.absMids[s] = absMids[s];
				if (!req.absMidsById[absMids[s]]) {
					req.absMidsById[absMids[s]] = s;
				}
			}
		}

		function resolveTernaryHasExpression(expr) { // eslint-disable-line no-unused-vars
			// Expects an expression of the form supported by dojo/has.js loader, except that module identifiers are
			// integers corresponding to webpack module ids.  Returns a module reference if evaluation of the expression
			// using the currently defined features returns a module id, or else undefined.

			var has = findModule("dojo/has", null, false);
			var id = has.normalize(expr, function(arg){return arg;});
			return id && __webpack_require__(id) || undefined;
		}

		function findModule(mid, referenceModule, noInstall, asModuleObj) {
			mid = mid.split("!").map(function(segment) {
				var isRelative = segment.charAt(0) === '.';
				if(isRelative && !referenceModule){
					return segment;
				}
				return toAbsMid(segment, referenceModule ? {mid: referenceModule} : null);
			}).join("!");
			var result;
			if (mid in req.absMids && __webpack_require__.m[req.absMids[mid]]) {
				if (noInstall) {
					var module = __webpack_module_cache__[req.absMids[mid]];
					result = module && (asModuleObj ? module : module.exports);
				} else {
					result = __webpack_require__(req.absMids[mid]);
				}
			}
			if (!result) {
				throw new Error('Module not found: ' + mid);
			}
			return result;
		}

		function dojoModuleFromWebpackModule(webpackModule) { // eslint-disable-line no-unused-vars
			if (webpackModule.absMid) return webpackModule;  // Already converted
			var result = {i:webpackModule.id};
			var id = req.absMidsById[webpackModule.id];
			if (id) {
				result.id = result.absMid = id;
			}
			Object.defineProperty(result, "exports", {
				get: function() { return webpackModule.exports;},
				set: function(value) {webpackModule.exports = value;},
				enumerable: true,
				configurable: true
			});
			return result;
		}

		function contextRequire(a1, a2, a3, referenceModule, req) { // eslint-disable-line no-shadow
			var type = ({}.toString).call(a1);
			if (type === '[object String]') {
				// a3 is passed by require calls injected into dependency arrays for dependencies specified
				// as identifiers (vs. string literals).
				var noInstall = !(a3 === false);
				var m = findModule(a1, referenceModule, noInstall);
				if (typeof m === 'object' && m.__DOJO_WEBPACK_DEFINE_PROMISE__) {
					throw new Error('Module not found: ' + a1);
				}
				return m;
			} else if (type === '[object Object]') {
				throw new Error('Require config is not supported by WebPack');
			}
			if (type === '[object Array]') {
				var modules = [], callback = a2, errors = [];
				a1.forEach(function (mid) {
					try {
						modules.push(findModule(mid, referenceModule));
					} catch (e) {
						errors.push({mid: mid, error: e});
					}
				});
				if (errors.length === 0) {
					if (callback) {
						if (false && isDefinePromise(modules)) { // eslint-disable-line no-undef
							Promise.all(wrapPromises(modules)).then(function(deps) { // eslint-disable-line no-undef
								callback.apply(this, unwrapPromises(deps)); // eslint-disable-line no-undef
							}.bind(this)).catch(function(err){console.error(err);});
						} else {
							callback.apply(this, modules);
						}
					}
				} else {
					var error = new Error("findModules");
					error.src = "dojo-webpack-plugin";
					error.info = errors;
					req.signal("error", error);
				}
				return req;
			} else {
				throw new Error('Unsupported require call');
			}
		}
		req.toUrl = toUrl;
		req.toAbsMid = toAbsMid;
		req.absMids = {};
		req.absMidsById = [];
		req.async = 1;
	var globalObj = this||window;
	registerAbsMids({
		// "./lib-cjs/index" = 2090
		// "./__package__" = 2894
		"dojo/_base/declare":6345,
		"dojo/_base/kernel":1054,
		"dojo/global":1925,
		"dojo/has":6356,
		"dojo/_base/config":7361,
		"dojo/_base/lang":6323,
		"dojo/sniff":2616,
		"dojo/Deferred":5625,
		"dojo/errors/CancelError":1662,
		"dojo/errors/create":4332,
		"dojo/promise/Promise":5479,
		"dojo/promise/instrumentation":2236,
		"dojo/promise/tracer":3185,
		"dojo/Evented":9925,
		"dojo/aspect":6566,
		"dojo/on":2075,
		// "/home/runner/work/Visualization/Visualization/node_modules/dojo-webpack-plugin/lib/NoModule.js" = 8819
		"dojo/_base/array":6974,
		"dojo/dom-construct":28,
		"dojo/_base/window":5075,
		"dojo/dom":2284,
		"dojo/dom-attr":7878,
		"dojo/dom-style":1248,
		"dojo/dom-prop":5244,
		"dojo/_base/connect":5641,
		"dojo/topic":7111,
		"dojo/_base/event":3503,
		"dojo/dom-geometry":2685,
		"dojo/mouse":8471,
		"dojo/_base/sniff":3927,
		"dojo/keys":4266,
		"dojo-dstore/Memory":5907,
		"dojo-dstore/Store":1603,
		"dojo/when":3534,
		"dojo-dstore/QueryMethod":2219,
		"dojo-dstore/Filter":8942,
		"dojo-dstore/Promised":6739,
		"dojo-dstore/QueryResults":2626,
		"dojo-dstore/SimpleQuery":3060,
		"dgrid/Grid":1540,
		"dojo/dom-class":8945,
		"dgrid/List":4624,
		"dojo/query":1172,
		"dojo/selector/_loader":5226,
		"dojo/selector/lite":6178,
		"dojo/selector/_loader!default":6178,
		"dgrid/util/misc":4975,
		"dgrid/OnDemandGrid":5602,
		"dgrid/OnDemandList":6850,
		"dgrid/_StoreMixin":8301,
		"dgrid/Keyboard":9173,
		"dgrid/Selection":2348,
		"dgrid/util/touch":5892,
		"dgrid/ColumnSet":1996,
		"dgrid/extensions/ColumnResizer":5533,
		"dojo/_base/html":1142,
		"dgrid/extensions/CompoundColumns":297,
		"dgrid/extensions/nls/pagination":4481,
		// "./gridHelper" = 4808
		"dgrid/extensions/Pagination":6937,
		"dojo/string":7539,
		"dojo/i18n!dgrid/extensions/nls/pagination":1442,
		"dojo/i18n":3878,
		"dojo/_base/xhr":225,
		"dojo/io-query":6587,
		"dojo/dom-form":3159,
		"dojo/json":8212,
		"dojo/_base/Deferred":280,
		"dojo/_base/json":4861,
		"dojo/request/watch":3621,
		"dojo/request/util":5540,
		"dojo/errors/RequestError":8241,
		"dojo/errors/RequestTimeoutError":9608,
		"dojo/request/default!":9648,
		"dojo/request/xhr":9648,
		"dojo/request/handlers":2573,
		// "/home/runner/work/Visualization/Visualization/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js" = 5744
		"dijit/Tooltip":655,
		"dojo/_base/fx":5577,
		"dojo/_base/Color":1692,
		"dijit/_base/manager":9600,
		"dijit/registry":7601,
		"dijit/main":231,
		"dijit/place":1019,
		"dijit/Viewport":1600,
		"dojo/domReady":2641,
		"dojo/window":3930,
		"dijit/_Widget":3549,
		"dojo/ready":9671,
		"dijit/_WidgetBase":3068,
		"dojo/Stateful":4062,
		"dijit/Destroyable":6510,
		"dijit/_BidiMixin":5250,
		"dijit/_OnDijitClickMixin":8709,
		"dijit/a11yclick":8240,
		"dojo/touch":7443,
		"dijit/_FocusMixin":4368,
		"dijit/focus":7304,
		"dijit/a11y":3050,
		"dojo/uacss":2085,
		"dijit/hccss":664,
		"dojo/hccss":9276,
		"dijit/_TemplatedMixin":998,
		"dojo/cache":4642,
		"dojo/text":9445,
		"dojo/request":8769,
		"dijit/_AttachMixin":5659,
		"dijit/BackgroundIframe":610,
		"dojo/text!dijit/templates/Tooltip.html":9409,
		"dojo/_base/query":4203,
		"dojo/_base/NodeList":6659,
		"dojo/NodeList-dom":8288
		// "/tmp/tmp-2722-fWGlg7W1TV0B/dojo/dojo.js" = 2319
	});

	globalObj.require = req;
		(self["webpackChunk_hpcc_js_dgrid_shim"] = self["webpackChunk_hpcc_js_dgrid_shim"] || []).registerAbsMids = registerAbsMids;

	// expose the Dojo compatibility functions as a properties of __webpack_require__
	if (__webpack_require__.dj && __webpack_require__.dj.name !== 'dojo-webpack-plugin') throw new Error("__webpack_require__.dj name collision.")
	__webpack_require__.dj = {
		name: 'dojo-webpack-plugin',
		r: req,
		c: createContextRequire,
		m: dojoModuleFromWebpackModule,
		h: resolveTernaryHasExpression,
	};
	var loaderScope = Object.create(globalObj, {
	   document:{value: globalObj.document},
	});
	Object.defineProperties(loaderScope, {
	   window:{value:loaderScope},
	   global:{value:loaderScope}
	});
	loaderScope.define = loaderScope.require = undefined
	globalObj.dojoConfig = globalObj.dojoConfig || {}
	var userConfig = mix(globalObj.dojoConfig, ({'baseUrl':'.','deps':['lib/index'],'async':true,'has':({'dojo-config-api':false}),'selectorEngine':'lite','fixupUrl':(function (url) {
				// Load the uncompressed versions of dojo/dijit/dojox javascript files when using the dojo loader.
				// When using a webpack build, the dojo loader is not used for loading javascript files so this
				// property has no effect.  This is only needed because we're loading Dojo from a CDN for this
				// demo.  In a normal development envorinment, Dojo would be installed locally and this wouldn't
				// be needed.
				if (/\/(dojo|dijit|dojox)\/.*\.js$/.test(url)) {
					url += ".uncompressed.js";
				}
				return url;
			})}));
	var defaultConfig = ({'hasCache':({'webpack':1,'host-browser':1,'dom':1,'dojo-loader':1,'dojo-has-api':1,'dojo-dom-ready-api':1,'dojo-sniff':1,'dojo-test-sniff':1,'config-deferredInstrumentation':1,'config-tlmSiblingOfDojo':1}),'paths':({'js':'js','theme':'theme','css':'//chuckdumont.github.io/dojo-css-plugin/1.0.0/css'}),'pathsMapProg':[['theme','theme',/^theme(\/|$)/,5],['css','//chuckdumont.github.io/dojo-css-plugin/1.0.0/css',/^css(\/|$)/,3],['js','js',/^js(\/|$)/,2]],'packs':({'dojo':({'main':'main','name':'dojo','location':'./dist/dojo','lib':'.'}),'dijit':({'main':'main','name':'dijit','location':'./dist/dijit','lib':'.'}),'dojox':({'main':'main','name':'dojox','location':'./dist/dojox','lib':'.'}),'dijit-themes':({'main':'main','name':'dijit-themes','location':'./dist/dijit-themes','lib':'.'}),'dgrid':({'main':'main','name':'dgrid','location':'./dist/dgrid','lib':'.'}),'dstore':({'main':'main','name':'dstore','location':'./dist/dojo-dstore','lib':'.'})}),'aliases':[],'mapProgs':[],'cacheBust':undefined,'modules':({}),'cache':({})});
	var dojoLoader = __webpack_require__(2319);
	dojoLoader.call(loaderScope, userConfig, defaultConfig, loaderScope, loaderScope);
	loaderScope.require.baseUrl = "./";
	Object.keys(loaderScope.require.packs).forEach(function(key) {
		var pkg = loaderScope.require.packs[key];
		if ((/(^\/)|(\:)/.test(pkg.main)	// main path is absolute
		    || pkg.main.split('/').reduce(function(acc, pathComp) {
					if (acc < 0 || pathComp === '.') return acc;
					return (pathComp === '..' ? --acc : ++acc);
				}, 0) <= 0) // main path is outside package
				&& typeof pkg.realMain === 'undefined'	// hasn't already been adjusted
		) {
			pkg.realMain = pkg.main;
			pkg.main = '';
		}
	});
	function toAbsMid(name, referenceModule) {
		var absMid = loaderScope.require.originalToAbsMid(name, referenceModule);
		if (absMid.indexOf('/') === absMid.length-1) {
			var pkgName = absMid.substring(0, absMid.length-1);
			var pkg = loaderScope.require.packs[pkgName];
			if (pkg && pkg.realMain) {
				absMid = pkgName;
			}
		}
		return absMid;
	}
	function toUrl(name, referenceModule) {
		var url = loaderScope.require.originalToUrl(name, referenceModule);
		var pkg = loaderScope.require.packs[name];
		if (pkg && pkg.realMain) {
			var parts = url.split('?');
			if (/(^\/)|(\:)/.test(pkg.realMain)) {
				// absolute URL
				parts[0] = pkg.realMain;
			} else {
				// relative URL
				parts[0] = parts[0] + '/' + pkg.realMain;
			}
			url = parts.join('?');
		}
		return url;
	}
	loaderScope.require.originalToAbsMid = loaderScope.require.toAbsMid;
	loaderScope.require.originalToUrl = loaderScope.require.toUrl;
	loaderScope.require.toAbsMid = toAbsMid;
	loaderScope.require.toUrl = toUrl;
	['baseUrl','has','rawConfig','on','signal'].forEach(function(name) {req[name] = loaderScope.require[name]})
	var absMidsWaiting = globalObj["webpackChunk_hpcc_js_dgrid_shim"].absMidsWaiting;
	if (absMidsWaiting) {
	   absMidsWaiting.forEach(registerAbsMids);
	   delete globalObj["webpackChunk_hpcc_js_dgrid_shim"].absMidsWaiting;
	}
})(); /* End dojo-webpack-plugin extensions */